import React, { memo } from 'react'
import classNames from 'classnames'
import LaneArrowIcon from 'transfix-icons/build/LaneArrowIcon'
import { Box, Skeleton } from 'transfix-ui/core'
import { IFullStop, STOP_TYPE } from 'types'
import { useStopSummaryStyles } from 'apps/fleet-planner/components/load-details/stops//StopsSummaryStyles'
import { MarketplaceStopConfirmationItem } from './MarketplaceStopConfirmationItem'

interface IMarketplaceMarketplaceStopSummaryProps {
  stops?: IFullStop[]
  className?: string
  compact?: boolean
}

const getPickupCount = (stops: IFullStop[] = []): number => {
  const filteredStops = stops.filter(({ type }) => type === STOP_TYPE.pickup)
  return filteredStops.length
}

const getDropoffCount = (stops: IFullStop[] = []): number => {
  const filteredStops = stops.filter(({ type }) => type === STOP_TYPE.delivery)
  return filteredStops.length
}

const getStopNumber = (stop?: IFullStop, allStops: IFullStop[] = []): number => {
  const pickupCount = getPickupCount(allStops)
  const dropoffCount = getDropoffCount(allStops)

  const { stopSequence = 1, type } = stop || {}
  let stopNumber = 0
  if (type === STOP_TYPE.pickup && pickupCount > 1) {
    stopNumber = stopSequence
  } else if (type === STOP_TYPE.delivery && dropoffCount > 1) {
    stopNumber = stopSequence - pickupCount
  }

  return stopNumber
}

export const MarketplaceStopConfirmation = memo<IMarketplaceMarketplaceStopSummaryProps>(
  ({ stops = [], className, compact = false }) => {
    const styles = useStopSummaryStyles({ compact })
    const classes = classNames(styles.root, className)
    const hasLoaded = stops.length !== 0

    return (
      <Box className={classes} data-test='stops-summary'>
        {hasLoaded ? (
          <>
            {stops.map((stop, i) => (
              <MarketplaceStopConfirmationItem
                key={stop.id}
                stop={stop}
                stopNumber={getStopNumber(stop, stops)}
                compact={compact}
                last={i + 1 === stops.length}
              />
            ))}
          </>
        ) : (
          <>
            <Box>
              <Box marginBottom='3px'>
                <Skeleton variant='rectangular' height={20} width={190} />
              </Box>
              <Skeleton variant='rectangular' height={22} width={145} />
            </Box>

            <Box className={styles.icon}>
              <LaneArrowIcon size='xlarge' color='coolGray5' />
            </Box>
            <Box>
              <Box marginBottom='3px'>
                <Skeleton variant='rectangular' height={20} width={190} />
              </Box>
              <Skeleton variant='rectangular' height={22} width={145} />
            </Box>
          </>
        )}
      </Box>
    )
  }
)
